import React, { useState, useEffect } from 'react';
import { auth, db } from '../services/firebase';
import { collection, query, where, onSnapshot, addDoc, deleteDoc, doc, updateDoc, serverTimestamp, getDoc, getDocs, orderBy, limit } from 'firebase/firestore';
import { Box, Typography, Card, CardContent, TextField, Button, List, ListItem, ListItemText, ListItemAvatar, Avatar, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Select, MenuItem, FormControl, InputLabel, Grid, Chip, Tooltip, Stack, Divider, Checkbox, InputAdornment } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import InventoryIcon from '@mui/icons-material/Inventory';
import BuildIcon from '@mui/icons-material/Build';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import CategoryIcon from '@mui/icons-material/Category';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import HistoryIcon from '@mui/icons-material/History';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { Html5QrcodeScanner } from 'html5-qrcode';
import styles from '../styles/Dashboard.module.css';
import { format } from 'date-fns'; // Import format from date-fns
import { v4 as uuidv4 } from 'uuid';

import CatalogBrowser from '../components/CatalogBrowser';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';

const ControleEstoque = () => {
  const [items, setItems] = useState([]);
  const [condominioId, setCondominioId] = useState('');
  const [userRole, setUserRole] = useState('');
  const [userName, setUserName] = useState('');
  const [userId, setUserId] = useState('');

  // Dialogs
  const [openDialog, setOpenDialog] = useState(false);
  const [openMovementDialog, setOpenMovementDialog] = useState(false);
  const [openBarcodeDialog, setOpenBarcodeDialog] = useState(false);
  const [openHistoryDialog, setOpenHistoryDialog] = useState(false);
  const [openShoppingDialog, setOpenShoppingDialog] = useState(false);
  const [showScanner, setShowScanner] = useState(false);

  // States
  const [currentItem, setCurrentItem] = useState(null);
  const [scannerInput, setScannerInput] = useState('');
  const [movementQty, setMovementQty] = useState(1);
  const [movementType, setMovementType] = useState('entrada'); // entrada | saida

  // History State
  const [historyItems, setHistoryItems] = useState([]);
  const [loadingHistory, setLoadingHistory] = useState(false);

  // Shopping List State
  const [condoData, setCondoData] = useState(null);
  const [shoppingItems, setShoppingItems] = useState([]);
  const [manualItemName, setManualItemName] = useState('');
  const [manualItemQty, setManualItemQty] = useState(1);
  const [manualItemCondoId, setManualItemCondoId] = useState(''); // Target Condo for Manual Item

  // Consumption Analysis State
  const [consumptionData, setConsumptionData] = useState({}); // { itemId: totalSaida30Dias }
  const [incomingStock, setIncomingStock] = useState({}); // { itemId: totalPendentes }

  // Filters & Selection
  const [filterName, setFilterName] = useState('');
  const [filterCategory, setFilterCategory] = useState('todos');
  const [filterStatus, setFilterStatus] = useState('todos'); // todos | baixo | normal
  const [selectedItems, setSelectedItems] = useState([]);

  // Administradora State
  /* Filters & Selection */
  /* Administradora State */
  const [managedCondos, setManagedCondos] = useState([]); // Array of condo objects
  const [condoFilter, setCondoFilter] = useState('todos');
  const [condosMap, setCondosMap] = useState({}); // { id: { nome, telefone_cotacao } }

  const [contactPhone, setContactPhone] = useState(''); // Stores the Selected Supplier Phone
  const [selectedSupplierId, setSelectedSupplierId] = useState('');
  const [suppliers, setSuppliers] = useState([]); // List of suppliers from DB

  const [formData, setFormData] = useState({
    nome: '',
    categoria: 'consumivel',
    quantidade: 0,
    descricao: '',
    localizacao: '',
    codigo_barras: '',
    estoque_minimo: 5,
    unidade_medida: 'un'
  });

  useEffect(() => {
    const unsubscribeAuth = auth.onAuthStateChanged(async (user) => {
      if (user) {
        setUserId(user.uid);
        const userDocRef = doc(db, 'tb_usuarios', user.uid);
        const userDoc = await getDoc(userDocRef);
        if (userDoc.exists()) {
          const data = userDoc.data();
          setUserRole(data.papel);
          setUserName(data.nome || 'Usuário');

          if (data.papel === 'administradora') {
            // Fetch managed condos
            const condosQ = query(collection(db, 'tb_condominios'), where('administradora_id', '==', user.uid));
            const condosSnap = await getDocs(condosQ);
            const managed = condosSnap.docs.map(d => ({ id: d.id, ...d.data() }));
            setManagedCondos(managed);

            // Map for easy access
            const cMap = {};
            managed.forEach(c => cMap[c.id] = c);
            setCondosMap(cMap);

          } else {
            setCondominioId(data.condominio_id);
          }
        }
      }
    });
    return () => unsubscribeAuth();
  }, []);

  useEffect(() => {
    let q;
    if (userRole === 'administradora') {
      if (managedCondos.length === 0) return;
      const condoIds = managedCondos.map(c => c.id);
      // Firestore 'in' limit is 30. Assuming < 30 for now.
      q = query(collection(db, 'tb_estoque'), where('condominio_id', 'in', condoIds));
    } else {
      if (!condominioId) return;
      q = query(collection(db, 'tb_estoque'), where('condominio_id', '==', condominioId));
    }

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const list = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setItems(list);
    });
    return () => unsubscribe();
  }, [condominioId, userRole, managedCondos]);

  // Fetch Pending Purchase Orders (Incoming Stock)
  useEffect(() => {
    let qOps;
    if (userRole === 'administradora') {
      if (managedCondos.length === 0) return;
      // Ideally filter by condo, but PO usually links to quote -> items have condo_id?
      // Let's simplified: fetch all pending POs if admin_system, or if administradora fetch pending POs created via her quotes?
      // Actually, PO contains items. We need to aggregate all PENDING POs related to the condos we manage.
      // For simplicity: fetch ALL 'pendente' POs and filter in memory if needed, or if security allows.
      qOps = query(collection(db, 'tb_ordens_compra'), where('status', '==', 'pendente'));
    } else {
      // If single condo, we also need to see if there are POs that include our items.
      // It's harder to filter deep inside array 'itens'.
      // For now, let's just fetch all 'pendente' and filter client side by matching item IDs (since item_id is unique per condo usually, assuming DB structure).
      qOps = query(collection(db, 'tb_ordens_compra'), where('status', '==', 'pendente'));
    }

    const unsub = onSnapshot(qOps, (snap) => {
      const incoming = {};
      snap.docs.forEach(doc => {
        const data = doc.data();
        if (data.itens) {
          data.itens.forEach(i => {
            // Start Incoming Count
            if (!incoming[i.item_id]) incoming[i.item_id] = 0;
            incoming[i.item_id] += (parseFloat(i.quantidade) || 0);
          });
        }
      });
      setIncomingStock(incoming);
    });
    return () => unsub();
  }, [userRole, managedCondos]);

  // Fetch Condo Data (Phone)
  // Fetch Condo Data (Phone) - for Single User (Non-Admin)
  useEffect(() => {
    // If administradora, we already fetched data in the Auth effect
    if (userRole === 'administradora' || !condominioId) return;
    const fetchCondo = async () => {
      const docRef = doc(db, 'tb_condominios', condominioId);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const data = docSnap.data();
        setCondoData(data);
        setCondosMap({ [condominioId]: data }); // Uniform access
      }
    };
    fetchCondo();
  }, [condominioId, userRole]);

  // Fetch Consumption History (Last 30 Days)
  // Fetch Consumption History (Last 30 Days)
  useEffect(() => {
    // Determine scope
    let targetCondoIds = [];
    if (userRole === 'administradora') {
      if (managedCondos.length === 0) return;
      targetCondoIds = managedCondos.map(c => c.id);
    } else {
      if (!condominioId) return;
      targetCondoIds = [condominioId];
    }

    const fetchConsumption = async () => {
      const thirtyDaysAgo = new Date();
      thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);

      // Query all 'saida' in the last 30 days
      const q = query(
        collection(db, 'tb_estoque_historico'),
        where('condominio_id', 'in', targetCondoIds), // Use IN
        where('tipo', '==', 'saida'),
        where('data', '>=', thirtyDaysAgo)
      );

      try {
        const snapshot = await getDocs(q);
        const consumption = {};

        snapshot.forEach(doc => {
          const data = doc.data();
          if (data.item_id) {
            consumption[data.item_id] = (consumption[data.item_id] || 0) + data.quantidade;
          }
        });
        setConsumptionData(consumption);
      } catch (error) {
        console.error("Erro ao calcular consumo:", error);
      }
    };

    fetchConsumption();
  }, [condominioId, userRole, managedCondos]);

  const getCoverageInfo = (item) => {
    const totalSaida30 = consumptionData[item.id] || 0;
    if (totalSaida30 === 0) return null; // Sem consumo recente

    const mediaDiaria = totalSaida30 / 30;
    const diasCobertura = item.quantidade / mediaDiaria;

    return {
      dias: Math.floor(diasCobertura),
      saida30: totalSaida30
    };
  };

  // --- LOGGING ---
  const logAction = async (tipo, item, quantidade, novaQuantidade) => {
    try {
      await addDoc(collection(db, 'tb_estoque_historico'), {
        item_id: item.id || '', // pode ser vazio se for criação, mas idealmente pegamos o ID depois
        item_nome: item.nome,
        usuario_id: userId,
        usuario_nome: userName,
        tipo: tipo, // 'entrada', 'saida', 'criacao', 'edicao', 'exclusao'
        quantidade: Number(quantidade),
        nova_quantidade: Number(novaQuantidade),
        condominio_id: condominioId,
        data: serverTimestamp()
      });
    } catch (error) {
      console.error("Erro ao registrar histórico:", error);
    }
  };

  // --- CRUD ---

  const handleOpenDialog = (item = null) => {
    if (item) {
      setCurrentItem(item);
      setFormData({
        nome: item.nome,
        categoria: item.categoria,
        quantidade: item.quantidade,
        descricao: item.descricao || '',
        localizacao: item.localizacao || '',
        codigo_barras: item.codigo_barras || '',
        estoque_minimo: item.estoque_minimo || 5,
        unidade_medida: item.unidade_medida || 'un'
      });
    } else {
      setCurrentItem(null);
      setFormData({
        nome: '',
        categoria: 'consumivel',
        quantidade: 0,
        descricao: '',
        localizacao: '',
        codigo_barras: '',
        estoque_minimo: 5,
        unidade_medida: 'un'
      });
    }
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setCurrentItem(null);
  };

  const handleSave = async () => {
    if (!formData.nome || formData.quantidade < 0) {
      alert('Preencha o nome e uma quantidade válida.');
      return;
    }

    try {
      const dataToSave = {
        ...formData,
        quantidade: Number(formData.quantidade),
        estoque_minimo: Number(formData.estoque_minimo)
      };

      if (currentItem) {
        await updateDoc(doc(db, 'tb_estoque', currentItem.id), dataToSave);
        await logAction('edicao', { ...dataToSave, id: currentItem.id }, 0, dataToSave.quantidade);
      } else {
        const docRef = await addDoc(collection(db, 'tb_estoque'), {
          ...dataToSave,
          condominio_id: condominioId,
          created_at: serverTimestamp()
        });
        await logAction('criacao', { ...dataToSave, id: docRef.id }, dataToSave.quantidade, dataToSave.quantidade);
      }
      handleCloseDialog();
    } catch (error) {
      console.error("Erro ao salvar item:", error);
      alert('Erro ao salvar item.');
    }
  };

  const handleDelete = async (item) => {
    if (item.quantidade > 0) {
      alert(`Não é possível excluir o item "${item.nome}" pois ele ainda possui ${item.quantidade} unidades em estoque.\nRealize uma movimentação de SAÍDA para zerar o estoque antes de excluir.`);
      return;
    }

    if (window.confirm('Tem certeza que deseja excluir este item?')) {
      try {
        await deleteDoc(doc(db, 'tb_estoque', item.id));
        await logAction('exclusao', item, item.quantidade, 0);
      } catch (error) {
        console.error("Erro ao excluir:", error);
      }
    }
  };

  // --- Movimentação por Código de Barras ---

  const handleOpenBarcodeScanner = () => {
    setScannerInput('');
    setShowScanner(false);
    setOpenBarcodeDialog(true);
  };

  const processBarcode = (code) => {
    if (!code) return;

    const foundItem = items.find(i => i.codigo_barras === code);

    if (foundItem) {
      setCurrentItem(foundItem);
      setMovementQty(1);
      setMovementType('saida');
      setScannerInput(code); // Update input to show what was found
      setOpenBarcodeDialog(false);
      setOpenMovementDialog(true);
    } else {
      if (window.confirm(`Código "${code}" não encontrado. Deseja cadastrar um novo item?`)) {
        setOpenBarcodeDialog(false);
        setCurrentItem(null);
        setFormData({
          nome: '',
          categoria: 'consumivel',
          quantidade: 0,
          descricao: '',
          localizacao: '',
          codigo_barras: code,
          estoque_minimo: 5,
          unidade_medida: 'un'
        });
        setOpenDialog(true);
      }
    }
  };

  const handleBarcodeSubmit = () => {
    processBarcode(scannerInput);
  };

  const onScanSuccess = (decodedText, decodedResult) => {
    // Parar o scanner após sucesso para evitar múltiplas leituras
    setShowScanner(false);
    setScannerInput(decodedText);

    // Pequeno delay para garantir que o estado atualizou e o usuário percebeu
    setTimeout(() => {
      processBarcode(decodedText);
    }, 500);
  };

  useEffect(() => {
    if (showScanner && openBarcodeDialog) {
      // Html5QrcodeScanner creates UI automatically inside the element with id="reader"
      const scanner = new Html5QrcodeScanner(
        "reader",
        {
          fps: 10,
          qrbox: 250, // Caixa de foco visual
          aspectRatio: 1.0,
          showTorchButtonIfSupported: true,
          rememberLastUsedCamera: true,
          supportedScanTypes: [0, 1],
          videoConstraints: {
            facingMode: { exact: "environment" }, // Tenta forçar câmera traseira
            width: { min: 640, ideal: 1280, max: 1920 }, // Resolução maior ajuda no foco/leitura
            height: { min: 480, ideal: 720, max: 1080 },
            focusMode: "continuous", // Tentativa de ativar foco contínuo
            advanced: [{ focusMode: "continuous" }, { zoom: 2.0 }] // Tentativas extras
          },
          experimentalFeatures: {
            useBarCodeDetectorIfSupported: true // Tenta usar API nativa para desenhar a "caixa" verde
          }
        },
        /* verbose= */ false
      );

      // Embora a biblioteca tente detectar tudo, configurações experimentais podem ajudar
      // Mas o principal é garantir que a câmera foque corretamente.

      scanner.render(onScanSuccess, (error) => {
        // Ignore scan errors
      });

      return () => {
        scanner.clear().catch(error => console.error("Failed to clear scanner", error));
      };
    }
  }, [showScanner, openBarcodeDialog]);

  const handleMovementSubmit = async () => {
    if (!currentItem || movementQty <= 0) return;

    let newQty = currentItem.quantidade;
    const qtyChange = Number(movementQty);

    if (movementType === 'entrada') {
      newQty += qtyChange;
    } else {
      newQty -= qtyChange;
    }

    if (newQty < 0) {
      alert('Estoque insuficiente para esta retirada.');
      return;
    }

    try {
      await updateDoc(doc(db, 'tb_estoque', currentItem.id), {
        quantidade: newQty
      });
      await logAction(movementType, currentItem, qtyChange, newQty);

      setOpenMovementDialog(false);
      setCurrentItem(null);
    } catch (error) {
      console.error("Erro ao atualizar estoque:", error);
      alert('Erro ao atualizar estoque.');
    }
  };

  // --- History ---
  const handleOpenHistory = async (item) => {
    setCurrentItem(item);
    setOpenHistoryDialog(true);
    setLoadingHistory(true);
    setHistoryItems([]);

    try {
      const q = query(
        collection(db, 'tb_estoque_historico'),
        where('item_id', '==', item.id),
        orderBy('data', 'desc'),
        limit(50)
      );

      const historySnapshot = await getDocs(q);
      const history = historySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setHistoryItems(history);
    } catch (error) {
      console.error("Erro ao buscar histórico:", error);
    } finally {
      setLoadingHistory(false);
    }
  };

  // Fetch Suppliers (Global) - Only after Auth
  useEffect(() => {
    if (!userId) return; // Wait for auth

    const fetchSuppliers = async () => {
      try {
        const q = query(collection(db, 'tb_fornecedores'), orderBy('nome'));
        const snapshot = await getDocs(q);
        const list = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
        setSuppliers(list);
      } catch (error) {
        console.error("Erro ao buscar fornecedores", error);
      }
    };
    fetchSuppliers();
  }, [userId]);

  // --- Shopping List / Quote ---

  const handleOpenShoppingList = () => {
    // 1. Identify low stock items
    const lowStockItems = items.filter(i => {
      const min = i.estoque_minimo || 5;
      return i.quantidade < min;
    }).map(i => ({
      ...i,
      buyQty: (i.estoque_minimo || 5) - i.quantidade // Default suggestion: top up to min
    }));

    // 2. Add manually added items (if any, though 'shoppingItems' is usually ephemeral unless we persist it.
    // The current logic resets 'shoppingItems' to 'lowItems' every time we open.
    // If we want to KEEP manual selections, we should merge.
    // For now, simplicity: Overwrite or Merge if we had state.
    // But 'shoppingItems' is used as the cart.
    // Let's just set it to low items + existing shopping items if we want (but usually we start fresh or add to it).
    // The previous code verified low stock.
    // Let's keep simpler:
    setShoppingItems(lowStockItems);

    // 3. Reset Supplier Selection (Force user to choose)
    // Earlier behavior: default to condo phone. 
    // New Requirement: "não quero que nenhum role tenha a possibilidade de incluir livrimente um telefone"
    // So we reset or keep empty.
    setSelectedSupplierId('');
    setContactPhone('');

    setOpenShoppingDialog(true);
  };

  const handleSendQuote = async () => {
    if (shoppingItems.length === 0) {
      alert('A lista está vazia.');
      return;
    }

    if (!contactPhone) {
      alert(`Por favor, selecione um Fornecedor Homologado.`);
      return;
    }

    // 0. Check for Duplicates (Open quotes for same supplier)
    // We only care if there is an active process for this supplier to avoid overlapping requests.
    try {
      const dupQuery = query(
        collection(db, 'tb_cotacoes'),
        where('fornecedor_id', '==', selectedSupplierId),
        where('status', 'in', ['enviada', 'aguardando_resposta']) // Check active statuses
      );
      const dupSnap = await getDocs(dupQuery);
      if (!dupSnap.empty) {
        // Filter: Check if any item in current 'shoppingItems' is already in one of the active quotes
        let alreadyQuotedItems = [];
        dupSnap.docs.forEach(doc => {
          const qData = doc.data();
          if (qData.itens && Array.isArray(qData.itens)) {
            qData.itens.forEach(qItem => {
              // Check match by ID or Name
              const match = shoppingItems.find(si => si.nome === qItem.nome || (si.id && qItem.item_id && si.id === qItem.item_id));
              if (match) {
                alreadyQuotedItems.push(match.nome);
              }
            });
          }
        });

        if (alreadyQuotedItems.length > 0) {
          const uniqueItems = [...new Set(alreadyQuotedItems)];
          const confirmDup = window.confirm(`Atenção: Já existe uma cotação em andamento neste fornecedor contendo os itens: ${uniqueItems.join(', ')}. Deseja continuar e criar uma nova cotação mesmo assim?`);
          if (!confirmDup) return;
        }
      }
    } catch (err) {
      console.error("Erro ao verificar duplicidade", err);
    }

    // 1. Prepare Data for Firestore
    const selectedSupplier = suppliers.find(s => s.id === selectedSupplierId);

    // Flatten items with Condo Names for history
    const quoteItems = shoppingItems.map(item => {
      const cid = item.condominio_id || condominioId;
      // Resolve condo name similar to message logic
      let cName = 'Desconhecido';
      if (condosMap[cid]) cName = condosMap[cid].nome;
      else if (cid === condominioId && condoData) cName = condoData.nome;

      return {
        item_id: item.id || '',
        nome: item.nome,
        quantidade: item.buyQty,
        unidade: item.unidade_medida || 'un',
        condominio_id: cid,
        condominio_nome: cName,
        is_manual: !!item.isManual
      };
    }).filter(i => i.quantidade > 0);

    // 2. Save to Firestore
    const quoteToken = uuidv4(); // Generate unique token
    try {
      await addDoc(collection(db, 'tb_cotacoes'), {
        titulo: `Cotação de ${format(new Date(), 'dd/MM/yyyy')}`,
        status: 'enviada',
        token: quoteToken, // Save token
        data_criacao: serverTimestamp(),
        administradora_id: userRole === 'administradora' ? userId : null,
        author_uid: userId,
        fornecedor_id: selectedSupplierId || null,
        fornecedor_nome: selectedSupplier ? selectedSupplier.nome : 'Desconhecido',
        fornecedor_telefone: selectedSupplier ? selectedSupplier.telefone : null,
        fornecedor_email: selectedSupplier ? selectedSupplier.email : null,
        itens: quoteItems
      });
      alert("Cotação salva com sucesso e WhatsApp será aberto.");
    } catch (error) {
      console.error("Erro ao salvar cotação", error);
      alert("Erro ao salvar histórico da cotação, mas o WhatsApp será aberto.");
    }

    // 3. Build WhatsApp Message & Send
    // Calculate Total consolidated by Item Name/Code
    const totalByItem = {};
    shoppingItems.forEach(item => {
      const key = item.nome + (item.codigo_barras ? `-${item.codigo_barras}` : '');
      if (!totalByItem[key]) {
        totalByItem[key] = {
          nome: item.nome,
          code: item.codigo_barras,
          total: 0,
          unit: item.unidade_medida || 'un'
        };
      }
      totalByItem[key].total += (parseFloat(item.buyQty) || 0);
    });



    // Determine Responsavel Name (Sender)
    let senderName = userName;
    if (userRole === 'administradora') {
      senderName = `Administradora ${userName}`; // "Administradora" + Name
    } else {
      senderName = `${userName} (${condoData?.nome || 'Condomínio'})`;
    }

    const title = userRole === 'administradora' ? '*SOLICITAÇÃO DE COTAÇÃO UNIFICADA*' : '*SOLICITAÇÃO DE COTAÇÃO*';
    let message = `${title}\n`;
    message += `Responsável: ${senderName}\n\n`;

    // BLOCO 1: RESUMO CONSOLIDADO (TOTAL)
    message += `*📦 RESUMO DO PEDIDO (TOTAL - Para Orçamento)*\n`;
    Object.values(totalByItem).forEach(t => {
      if (t.total > 0) {
        const codeStr = t.code ? ` (Cód: ${t.code})` : '';
        message += `- ${t.nome}${codeStr}: *${t.total} ${t.unit}*\n`;
      }
    });

    message += `\n📝 *Por favor, preencha os valores no link abaixo para agilizar a aprovação:*\n`;
    message += `https://predioo.com/cotacao/${quoteToken}`;

    const encodedMessage = encodeURIComponent(message);
    const phone = contactPhone.replace(/\D/g, '');
    window.open(`https://wa.me/${phone}?text=${encodedMessage}`, '_blank');
  };

  const handleAddManualItem = () => {
    if (!manualItemName || manualItemQty <= 0) return;

    // For Administradora, must select condo
    let targetCondo = condominioId;
    if (userRole === 'administradora') {
      if (!manualItemCondoId) {
        alert("Selecione o condomínio para este item extra.");
        return;
      }
      targetCondo = manualItemCondoId;
    }

    const newItem = {
      id: `manual-${Date.now()}`,
      nome: manualItemName,
      quantidade: 0,
      estoque_minimo: 0,
      unidade_medida: 'un',
      buyQty: manualItemQty,
      condominio_id: targetCondo, // Assign Condo
      isManual: true
    };

    setShoppingItems([...shoppingItems, newItem]);
    setManualItemName('');
    setManualItemQty(1);
    setManualItemCondoId(''); // Reset selector
  };


  const getIcon = (categoria) => {
    switch (categoria) {
      case 'equipamento': return <BuildIcon />;
      case 'limpeza': return <CleaningServicesIcon />;
      default: return <CategoryIcon />;
    }
  };

  const isAdmin = ['sindico', 'sub_sindico', 'conselheiro', 'zelador', 'administradora'].includes(userRole);

  // State for sorting
  const [sortOrder, setSortOrder] = useState('nome_asc');

  const filteredItems = items.filter(item => {
    const matchesName = item.nome.toLowerCase().includes(filterName.toLowerCase());
    const matchesCategory = filterCategory === 'todos' || item.categoria === filterCategory;
    const matchesCondo = condoFilter === 'todos' || item.condominio_id === condoFilter;

    const minStock = item.estoque_minimo || 5;
    const incoming = incomingStock[item.id] || 0;
    const isLowStock = (item.quantidade + incoming) < minStock;
    let matchesStatus = true;
    if (filterStatus === 'baixo') matchesStatus = isLowStock;
    if (filterStatus === 'normal') matchesStatus = !isLowStock;

    return matchesName && matchesCategory && matchesStatus && matchesCondo;
  }).sort((a, b) => {
    switch (sortOrder) {
      case 'nome_asc': return a.nome.localeCompare(b.nome);
      case 'nome_desc': return b.nome.localeCompare(a.nome);
      case 'qtd_asc': return a.quantidade - b.quantidade;
      case 'qtd_desc': return b.quantidade - a.quantidade;
      case 'cat_asc': return a.categoria.localeCompare(b.categoria);
      default: return 0;
    }
  });

  const handleToggleSelect = (id) => {
    if (selectedItems.includes(id)) {
      setSelectedItems(selectedItems.filter(itemId => itemId !== id));
    } else {
      setSelectedItems([...selectedItems, id]);
    }
  };

  const handleBulkAddToQuote = () => {
    const itemsToAdd = items.filter(i => selectedItems.includes(i.id));

    // Create NEW list solely from selected items (User Request: Don't include previous/low-stock items)
    // Create NEW list solely from selected items (User Request: Don't include previous/low-stock items)
    const newShoppingList = itemsToAdd.map(item => {
      const incoming = incomingStock[item.id] || 0;
      const minStock = item.estoque_minimo || 5;
      // Suggestion: Max(0, Min - (Current + Incoming))
      // If result is 0, default to 1? Or 0? Let's default to 1 if user explicitly selected it, or 0 if auto?
      // User clicked "Add to Quote", so they probably want to buy. But if we Auto-Suggest, we should be smart.
      // Let's suggest Max(1, needed).
      const needed = Math.max(0, minStock - item.quantidade - incoming);
      return {
        ...item,
        buyQty: needed > 0 ? needed : 1
      };
    });

    setShoppingItems(newShoppingList);
    setOpenShoppingDialog(true);
    setSelectedItems([]); // Clear selection after adding
  };

  const [openCatalog, setOpenCatalog] = useState(false);

  const handleImportFromCatalog = (importedItem) => {
    // Check for duplicate barcode
    if (importedItem.codigo_barras) {
      const duplicate = items.find(i => i.codigo_barras === importedItem.codigo_barras);
      if (duplicate) {
        if (window.confirm(`O item "${duplicate.nome}" já existe no estoque com este código de barras (${duplicate.codigo_barras}).\nDeseja realizar uma movimentação ou edição neste item?`)) {
          // Open dialog in Edit Mode
          setCurrentItem(duplicate);
          setFormData({
            nome: duplicate.nome,
            categoria: duplicate.categoria,
            quantidade: duplicate.quantidade,
            descricao: duplicate.descricao || '',
            localizacao: duplicate.localizacao || '',
            codigo_barras: duplicate.codigo_barras,
            estoque_minimo: duplicate.estoque_minimo || 5,
            unidade_medida: duplicate.unidade_medida || 'un'
          });
          setOpenDialog(true);
        }
        return; // Stop creation flow
      }
    }

    setFormData({
      nome: importedItem.nome,
      categoria: importedItem.categoria,
      quantidade: 0,
      descricao: importedItem.descricao,
      localizacao: '',
      codigo_barras: importedItem.codigo_barras || '',
      estoque_minimo: 5,
      unidade_medida: importedItem.unidade_medida
    });
    setCurrentItem(null);
    setOpenDialog(true); // Open "Novo Item" dialog with pre-filled data
  };

  return (
    <Box>
      <Box component="main" sx={{ flexGrow: 1, p: { xs: 1, sm: 3 }, background: 'linear-gradient(45deg, #283593 30%, #1976d2 90%)', minHeight: '100vh', overflowX: 'hidden' }}>
        <Typography variant="h4" gutterBottom sx={{ color: 'white' }}>Controle de Estoque e Patrimônio</Typography>


        <Card className={styles.card} sx={{ mb: 3 }}>
          <CardContent sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
            <Button variant="contained" color="secondary" startIcon={<QrCodeScannerIcon />} onClick={handleOpenBarcodeScanner} fullWidth={false} sx={{ flexGrow: 1 }}>
              Movimentação Rápida
            </Button>


            {isAdmin && (
              <>
                <Button variant="outlined" startIcon={<InventoryIcon />} onClick={() => handleOpenDialog()} fullWidth={false} sx={{ flexGrow: 1 }}>
                  Novo Item
                </Button>
                <Button variant="outlined" color="info" startIcon={<CloudDownloadIcon />} onClick={() => setOpenCatalog(true)} fullWidth={false} sx={{ flexGrow: 1 }}>
                  Importar de Fornecedor
                </Button>
                <Button variant="outlined" color="primary" startIcon={<ShoppingCartIcon />} onClick={handleOpenShoppingList} fullWidth={false} sx={{ flexGrow: 1 }}>
                  Cotação / Compras
                </Button>
              </>
            )}
          </CardContent>
        </Card>

        {/* Catalog Browser Modal */}
        <CatalogBrowser
          open={openCatalog}
          onClose={() => setOpenCatalog(false)}
          suppliers={suppliers}
          onImport={handleImportFromCatalog}
        />

        <Card className={styles.card}>
          <CardContent>

            {/* Filters */}
            <Box sx={{ mb: 2, display: 'flex', gap: 2, flexWrap: 'wrap' }}>
              <TextField
                label="Buscar item..."
                variant="outlined"
                size="small"
                value={filterName}
                onChange={(e) => setFilterName(e.target.value)}
                sx={{ flexGrow: 1 }}
              />
              {userRole === 'administradora' && (
                <FormControl size="small" sx={{ minWidth: 150 }}>
                  <InputLabel>Condomínio</InputLabel>
                  <Select value={condoFilter} label="Condomínio" onChange={(e) => setCondoFilter(e.target.value)}>
                    <MenuItem value="todos">Todos</MenuItem>
                    {managedCondos.map(c => (
                      <MenuItem key={c.id} value={c.id}>{c.nome}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
              <FormControl size="small" sx={{ minWidth: 120 }}>
                <InputLabel>Categoria</InputLabel>
                <Select value={filterCategory} label="Categoria" onChange={(e) => setFilterCategory(e.target.value)}>
                  <MenuItem value="todos">Todas</MenuItem>
                  <MenuItem value="consumivel">Consumível</MenuItem>
                  <MenuItem value="limpeza">Limpeza</MenuItem>
                  <MenuItem value="equipamento">Equipamento</MenuItem>
                </Select>
              </FormControl>
              <FormControl size="small" sx={{ minWidth: 120 }}>
                <InputLabel>Status</InputLabel>
                <Select value={filterStatus} label="Status" onChange={(e) => setFilterStatus(e.target.value)}>
                  <MenuItem value="todos">Todos</MenuItem>
                  <MenuItem value="baixo">Baixo Estoque</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                </Select>
              </FormControl>
              <FormControl size="small" sx={{ minWidth: 150 }}>
                <InputLabel>Ordernar por</InputLabel>
                <Select value={sortOrder} label="Ordernar por" onChange={(e) => setSortOrder(e.target.value)}>
                  <MenuItem value="nome_asc">Nome (A-Z)</MenuItem>
                  <MenuItem value="nome_desc">Nome (Z-A)</MenuItem>
                  <MenuItem value="qtd_asc">Quantidade (Menor)</MenuItem>
                  <MenuItem value="qtd_desc">Quantidade (Maior)</MenuItem>
                  <MenuItem value="cat_asc">Categoria (A-Z)</MenuItem>
                </Select>
              </FormControl>
            </Box>

            {/* Bulk Actions */}
            {selectedItems.length > 0 && (
              <Box sx={{ mb: 2, p: 1, bgcolor: '#e3f2fd', borderRadius: 1, display: 'flex', alignItems: 'center', gap: 2 }}>
                <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                  {selectedItems.length} itens selecionados
                </Typography>
                <Button
                  variant="contained"
                  size="small"
                  startIcon={<ShoppingCartIcon />}
                  onClick={handleBulkAddToQuote}
                >
                  Adicionar à Cotação
                </Button>
                <Button size="small" onClick={() => setSelectedItems([])}>Cancelar</Button>
              </Box>
            )}

            <List>
              {filteredItems.map((item) => {
                const minStock = item.estoque_minimo || 5;
                const incoming = incomingStock[item.id] || 0;
                const lowStock = (item.quantidade + incoming) < minStock;

                return (
                  <ListItem key={item.id} divider sx={{ flexDirection: { xs: 'column', sm: 'row' }, alignItems: { xs: 'flex-start', sm: 'center' }, gap: 1 }}>
                    <Checkbox
                      checked={selectedItems.includes(item.id)}
                      onChange={() => handleToggleSelect(item.id)}
                    />
                    <ListItemAvatar>
                      <Avatar sx={{ bgcolor: item.categoria === 'equipamento' ? 'secondary.main' : 'primary.main' }}>
                        {getIcon(item.categoria)}
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      secondaryTypographyProps={{ component: 'div' }}
                      primaryTypographyProps={{ component: 'div' }}
                      primary={
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                          <Typography variant="h6">{item.nome}</Typography>
                          <Chip label={item.categoria.toUpperCase()} size="small" color={item.categoria === 'equipamento' ? 'secondary' : 'default'} variant="outlined" />
                          <Chip
                            label={`Qtd: ${item.quantidade} ${item.unidade_medida || 'un'}`}
                            size="small"
                            color={lowStock ? 'error' : 'primary'}
                            variant={lowStock ? 'filled' : 'outlined'}
                          />
                          {incoming > 0 && (
                            <Chip label={`Em Pedido: ${incoming}`} size="small" color="info" variant="filled" />
                          )}
                          {lowStock && <Chip label="Baixo Estoque" size="small" color="warning" sx={{ fontWeight: 'bold' }} />}

                          {/* Condo Chip for Admin */}
                          {userRole === 'administradora' && item.condominio_id && (
                            <Chip
                              label={condosMap[item.condominio_id]?.nome || 'Condo'}
                              size="small"
                              color="info"
                              variant="outlined"
                              sx={{ maxWidth: 120 }}
                            />
                          )}

                          {(() => {
                            const params = getCoverageInfo(item);
                            if (params) {
                              let color = 'success'; // > 15 dias
                              if (params.dias < 7) color = 'error'; // < 7 dias
                              else if (params.dias <= 15) color = 'warning'; // 7-15 dias

                              return (
                                <Chip
                                  label={`Cobertura: ~${params.dias} dias`}
                                  size="small"
                                  color={color}
                                  variant="outlined"
                                  title={`Baseado no consumo de ${params.saida30} unidades nos últimos 30 dias`}
                                />
                              );
                            } else {
                              return (
                                <Chip
                                  label="Sem consumo recente"
                                  size="small"
                                  variant="outlined"
                                  title="Não houve saídas nos últimos 30 dias para calcular a média"
                                  sx={{ borderColor: '#e0e0e0', color: '#9e9e9e' }}
                                />
                              );
                            }
                          })()}


                        </Box>
                      }
                      secondary={
                        <Box>
                          <Typography variant="body2" component="span" display="block">
                            {item.descricao}
                          </Typography>
                          {item.codigo_barras && (
                            <Typography variant="caption" display="block" color="text.secondary">
                              Cód: {item.codigo_barras}
                            </Typography>
                          )}
                          {item.localizacao && (
                            <Typography variant="caption" color="text.secondary">
                              Local: {item.localizacao}
                            </Typography>
                          )}
                        </Box>
                      }
                      sx={{ width: '100%', pr: { sm: 2 } }}
                    />
                    <Box sx={{ display: 'flex', gap: 1, alignSelf: { xs: 'flex-end', sm: 'center' }, mt: { xs: 1, sm: 0 } }}>
                      <Tooltip title="Ver Histórico">
                        <IconButton onClick={() => handleOpenHistory(item)}><HistoryIcon /></IconButton>
                      </Tooltip>
                      {isAdmin ? (
                        <>
                          <Tooltip title="Editar Detalhes">
                            <IconButton onClick={() => handleOpenDialog(item)}><EditIcon /></IconButton>
                          </Tooltip>
                          <Tooltip title="Excluir Item">
                            <IconButton onClick={() => handleDelete(item)}><DeleteIcon /></IconButton>
                          </Tooltip>
                        </>
                      ) : (
                        <Tooltip title="Ajustar Quantidade">
                          <IconButton onClick={() => {
                            setCurrentItem(item);
                            setMovementType('saida');
                            setMovementQty(1);
                            setOpenMovementDialog(true);
                          }}><EditIcon /></IconButton>
                        </Tooltip>
                      )}
                    </Box>
                  </ListItem>
                )
              })}
              {items.length === 0 && <Typography sx={{ p: 2 }}>Nenhum item cadastrado.</Typography>}
            </List>
          </CardContent>
        </Card>
      </Box>

      {/* Dialog History */}
      <Dialog open={openHistoryDialog} onClose={() => setOpenHistoryDialog(false)} fullWidth maxWidth="sm">
        <DialogTitle>Histórico: {currentItem?.nome}</DialogTitle>
        <DialogContent>
          {loadingHistory ? <Typography>Carregando...</Typography> : (
            <List>
              {historyItems.map((log) => (
                <ListItem key={log.id} divider>
                  <ListItemText
                    primaryTypographyProps={{ component: 'div' }}
                    secondaryTypographyProps={{ component: 'div' }}
                    primary={
                      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography variant="body1" sx={{ fontWeight: 'bold', textTransform: 'capitalize' }}>
                          {log.tipo}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          {log.data?.toDate().toLocaleString()}
                        </Typography>
                      </Box>
                    }
                    secondary={
                      <Box>
                        <Typography variant="body2">
                          Autor: <strong>{log.usuario_nome}</strong>
                        </Typography>
                        {log.tipo === 'entrada' && <Typography variant="body2" color="success.main">+ {log.quantidade} (Total: {log.nova_quantidade})</Typography>}
                        {log.tipo === 'saida' && <Typography variant="body2" color="error.main">- {log.quantidade} (Total: {log.nova_quantidade})</Typography>}
                        {(log.tipo === 'criacao' || log.tipo === 'edicao') && <Typography variant="body2">Qtd: {log.nova_quantidade}</Typography>}
                        {log.tipo === 'exclusao' && <Typography variant="body2" color="error">Item excluído</Typography>}
                      </Box>
                    }
                  />
                </ListItem>
              ))}
              {historyItems.length === 0 && <Typography>Nenhum histórico encontrado.</Typography>}
            </List>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenHistoryDialog(false)}>Fechar</Button>
        </DialogActions>
      </Dialog>

      {/* Dialog Cadastro/Edição Completa */}
      <Dialog open={openDialog} onClose={handleCloseDialog} fullWidth maxWidth="sm">
        <DialogTitle>{currentItem ? 'Editar Item' : 'Novo Item'}</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <TextField fullWidth label="Nome do Item" value={formData.nome} onChange={(e) => setFormData({ ...formData, nome: e.target.value })} />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Código de Barras"
                value={formData.codigo_barras}
                onChange={(e) => setFormData({ ...formData, codigo_barras: e.target.value })}
                InputProps={{
                  endAdornment: <QrCodeScannerIcon color="action" />
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Categoria</InputLabel>
                <Select value={formData.categoria} label="Categoria" onChange={(e) => setFormData({ ...formData, categoria: e.target.value })}>
                  <MenuItem value="consumivel">Consumível / Geral</MenuItem>
                  <MenuItem value="limpeza">Material de Limpeza</MenuItem>
                  <MenuItem value="equipamento">Equipamento / Patrimônio</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth type="number" label="Quantidade Atual" value={formData.quantidade} onChange={(e) => setFormData({ ...formData, quantidade: e.target.value })} />
            </Grid>

            {/* New Fields */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                type="number"
                label="Estoque Mínimo"
                value={formData.estoque_minimo}
                onChange={(e) => setFormData({ ...formData, estoque_minimo: e.target.value })}
                helperText="Avisa quando a qtd estiver abaixo."
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Unidade de Medida"
                placeholder="Ex: un, cx, kg, lt"
                value={formData.unidade_medida}
                onChange={(e) => setFormData({ ...formData, unidade_medida: e.target.value })}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField fullWidth label="Localização (Opcional)" placeholder="Ex: Depósito A, Portaria" value={formData.localizacao} onChange={(e) => setFormData({ ...formData, localizacao: e.target.value })} />
            </Grid>
            <Grid item xs={12}>
              <TextField fullWidth multiline rows={3} label="Descrição / Detalhes" placeholder="Marca, modelo, estado de conservação..." value={formData.descricao} onChange={(e) => setFormData({ ...formData, descricao: e.target.value })} />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Cancelar</Button>
          <Button variant="contained" onClick={handleSave}>Salvar</Button>
        </DialogActions>
      </Dialog>

      {/* Dialog Scanner Input */}
      <Dialog open={openBarcodeDialog} onClose={() => setOpenBarcodeDialog(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Movimentação Rápida</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Escaneie ou digite o código de barras do produto.
          </Typography>
          <TextField
            autoFocus
            fullWidth
            label="Código de Barras"
            value={scannerInput}
            onChange={(e) => setScannerInput(e.target.value)}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                handleBarcodeSubmit();
              }
            }}
            InputProps={{
              endAdornment: (
                <IconButton onClick={() => setShowScanner(!showScanner)}>
                  <CameraAltIcon color={showScanner ? "primary" : "action"} />
                </IconButton>
              )
            }}
          />

          {showScanner && (
            <Box sx={{ mt: 2, textAlign: 'center' }}>
              <Typography variant="caption" display="block" sx={{ mb: 1 }}>Aponte a câmera para o código</Typography>
              <div id="reader" width="100%"></div>
            </Box>
          )}

        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenBarcodeDialog(false)}>Cancelar</Button>
          {!showScanner && <Button variant="contained" onClick={handleBarcodeSubmit}>Buscar</Button>}
        </DialogActions>
      </Dialog>

      {/* Dialog Movimentação (Entrada/Saída) */}
      <Dialog open={openMovementDialog} onClose={() => setOpenMovementDialog(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Atualizar Estoque: {currentItem?.nome}</DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
            <Chip label={`Estoque Atual: ${currentItem?.quantidade} ${currentItem?.unidade_medida || 'un'}`} color="primary" />
          </Box>

          <Stack direction="row" spacing={2} sx={{ mb: 2, mt: 1 }}>
            <Button
              variant={movementType === 'entrada' ? 'contained' : 'outlined'}
              color="success"
              startIcon={<AddIcon />}
              onClick={() => setMovementType('entrada')}
              fullWidth
            >
              Entrada
            </Button>
            <Button
              variant={movementType === 'saida' ? 'contained' : 'outlined'}
              color="error"
              startIcon={<RemoveIcon />}
              onClick={() => setMovementType('saida')}
              fullWidth
            >
              Saída/Uso
            </Button>
          </Stack>

          <TextField
            fullWidth
            type="number"
            label="Quantidade"
            value={movementQty}
            onChange={(e) => setMovementQty(e.target.value)}
            InputProps={{ inputProps: { min: 1 } }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenMovementDialog(false)}>Cancelar</Button>
          <Button variant="contained" onClick={handleMovementSubmit}>Confirmar</Button>
        </DialogActions>
      </Dialog>

      {/* Dialog Shopping List */}
      <Dialog open={openShoppingDialog} onClose={() => setOpenShoppingDialog(false)} fullWidth maxWidth="sm">
        <DialogTitle>Lista de Compras / Cotação</DialogTitle>
        <DialogContent>
          {/* Supplier Select */}
          <FormControl fullWidth margin="dense">
            <InputLabel>Selecione o Fornecedor</InputLabel>
            <Select
              value={selectedSupplierId}
              label="Selecione o Fornecedor"
              onChange={(e) => {
                const sid = e.target.value;
                setSelectedSupplierId(sid);
                const sup = suppliers.find(s => s.id === sid);
                if (sup) setContactPhone(sup.telefone);
              }}
            >
              {suppliers.map(sup => (
                <MenuItem key={sup.id} value={sup.id}>
                  {sup.nome} ({sup.categoria || 'Geral'})
                </MenuItem>
              ))}
              {suppliers.length === 0 && <MenuItem disabled>Nenhum fornecedor cadastrado. Contate o Admin.</MenuItem>}
            </Select>
          </FormControl>

          {contactPhone && (
            <Typography variant="caption" sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 1, color: 'success.main' }}>
              <WhatsAppIcon fontSize="inherit" /> Enviar para: {contactPhone}
            </Typography>
          )}

          <Divider sx={{ my: 2 }} />

          {/* Manual Add Section */}
          <Box sx={{ mb: 2, p: 1, border: '1px solid #eee', borderRadius: 1 }}>
            <Typography variant="subtitle2" gutterBottom>Adicionar item extra:</Typography>
            <Grid container spacing={1} alignItems="center">
              {/* Condo Select (Only for Admins with options) */}
              {userRole === 'administradora' && managedCondos.length > 0 && (
                <Grid item xs={12} sm={4}>
                  <FormControl size="small" fullWidth>
                    <InputLabel>Condomínio</InputLabel>
                    <Select
                      value={manualItemCondoId}
                      label="Condomínio"
                      onChange={(e) => setManualItemCondoId(e.target.value)}
                    >
                      {managedCondos.map(c => (
                        <MenuItem key={c.id} value={c.id}>{c.nome}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              )}

              <Grid item xs={userRole === 'administradora' ? 8 : 8} sm>
                <TextField
                  label="Nome do item extra"
                  size="small"
                  fullWidth
                  value={manualItemName}
                  onChange={(e) => setManualItemName(e.target.value)}
                />
              </Grid>

              <Grid item xs={userRole === 'administradora' ? 4 : 4} sm={2}>
                <TextField
                  label="Qtd"
                  type="number"
                  size="small"
                  fullWidth
                  value={manualItemQty}
                  onChange={(e) => setManualItemQty(e.target.value)}
                  InputProps={{ inputProps: { min: 1 } }}
                />
              </Grid>

              <Grid item>
                <Button variant="contained" size="medium" onClick={handleAddManualItem} sx={{ minWidth: 40, p: 1 }}>
                  <AddIcon />
                </Button>
              </Grid>
            </Grid>
          </Box>

          <Typography variant="body2" sx={{ mb: 2 }}>
            Itens com estoque abaixo do mínimo foram adicionados automaticamente. Ajuste as quantidades.
          </Typography>
          <List>
            {shoppingItems.length === 0 ? (
              <Typography sx={{ p: 2, textAlign: 'center', color: 'text.secondary' }}>Tudo certo! Nenhum item com estoque baixo.</Typography>
            ) : (
              shoppingItems.map((item, index) => (
                <ListItem key={item.id} divider>
                  <ListItemText
                    primary={item.nome}
                    secondary={
                      <>
                        {item.codigo_barras && <Typography variant="caption" display="block">Cód: {item.codigo_barras}</Typography>}
                        <span>Atual: {item.quantidade} | Mín: {item.estoque_minimo || 5}</span>
                      </>
                    }
                  />
                  <TextField
                    type="number"
                    label="Qtd Comprar"
                    size="small"
                    sx={{ width: 100 }}
                    value={item.buyQty}
                    onChange={(e) => {
                      const newItems = [...shoppingItems];
                      newItems[index].buyQty = e.target.value;
                      setShoppingItems(newItems);
                    }}
                  />
                </ListItem>
              ))
            )}
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenShoppingDialog(false)}>Fechar</Button>
          <Button
            variant="contained"
            color="success"
            startIcon={<WhatsAppIcon />}
            onClick={handleSendQuote}
            disabled={!contactPhone || shoppingItems.length === 0}
          >
            Solicitar no WhatsApp
          </Button>
        </DialogActions>
      </Dialog>

    </Box>
  );
};

export default ControleEstoque;
